import React from "react";
import { colors } from "../../styles/designTokens";

export type ConversionStepState =
  | "complete"
  | "failed"
  | "active"
  | "pending";

const PENDING_STROKE = "#45454A";
const PENDING_LABEL = "#78787C";

interface ConversionStepMarkerProps {
  state: ConversionStepState;
  /** 1-based step number shown on markers that have not run yet. */
  stepNumber: number;
  /** View R UI FCV `4133:76628` Marker box. */
  size: number;
}

/**
 * 변환 단계 마커.
 *
 * FCV 정본(View R UI `2903:98902`)은 상태를 색이 아니라 모양으로 말한다.
 * 완료는 초록 원에 체크, 실패는 빨강 원에 X, 미도달은 회색 테두리 원에 단계
 * 번호다. 흑백으로 봐도 어디서 멈췄는지 읽혀야 하므로 색만으로 구분하지
 * 않는다. 진행 중인 단계는 Primary 테두리 원에 같은 번호를 쓴다.
 */
const ConversionStepMarker: React.FC<ConversionStepMarkerProps> = ({
  state,
  stepNumber,
  size,
}) => {
  const fill =
    state === "complete"
      ? colors.primary[50].dark
      : state === "failed"
        ? colors.red[50].dark
        : "transparent";
  const stroke =
    state === "complete"
      ? colors.primary[50].dark
      : state === "failed"
        ? colors.red[50].dark
        : state === "active"
          ? colors.primary[50].dark
          : PENDING_STROKE;
  const numberColor =
    state === "active" ? colors.primary[50].dark : PENDING_LABEL;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      data-step-state={state}
      style={{ display: "block", flexShrink: 0 }}
    >
      <circle cx="12" cy="12" r="9" fill={fill} stroke={stroke} strokeWidth="2" />
      {state === "complete" && (
        <path
          d="M8 12.2l2.6 2.6L16 9.4"
          stroke={colors.common[100].dark}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {state === "failed" && (
        <path
          d="M9 9l6 6M15 9l-6 6"
          stroke={colors.common[100].dark}
          strokeWidth="2"
          strokeLinecap="round"
        />
      )}
      {(state === "pending" || state === "active") && (
        <text
          x="12"
          y="12"
          textAnchor="middle"
          dominantBaseline="central"
          fill={numberColor}
          fontSize="13"
          fontWeight="500"
          fontFamily="Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, sans-serif"
        >
          {stepNumber}
        </text>
      )}
    </svg>
  );
};

export default ConversionStepMarker;
